.progress-bar {
  height: 2px;
  width: 100%;
}
